import { render, staticRenderFns } from "./OrderPackUpModal.vue?vue&type=template&id=3b59ff01&"
import script from "./OrderPackUpModal.vue?vue&type=script&lang=js&"
export * from "./OrderPackUpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports